document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initFaq();
  initGaleriaProducto();
  initVariantesProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });

  // Salvaguarda: si por lo que sea el observer no llega a disparar
  // (pestaña en segundo plano largo tiempo, navegador atípico...),
  // el contenido no debe quedar invisible para siempre.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 4000);
}

function initContador() {
  var barra = document.querySelector('[data-mt-contador]');
  if (!barra) return;
  var horas = parseFloat(barra.getAttribute('data-duracion-horas')) || 48;
  var ancla = barra.getAttribute('data-ancla');
  var elD = barra.querySelector('[data-u="d"]');
  var elH = barra.querySelector('[data-u="h"]');
  var elM = barra.querySelector('[data-u="m"]');
  var elS = barra.querySelector('[data-u="s"]');

  var anclaMs = ancla ? new Date(ancla).getTime() : 0;
  var cicloMs = horas * 60 * 60 * 1000;
  if (isNaN(anclaMs)) anclaMs = 0;

  function tick() {
    var ahora = new Date().getTime();
    var transcurrido = (ahora - anclaMs) % cicloMs;
    if (transcurrido < 0) transcurrido += cicloMs;
    var restante = cicloMs - transcurrido;

    var d = Math.floor(restante / (1000 * 60 * 60 * 24));
    var h = Math.floor((restante / (1000 * 60 * 60)) % 24);
    var m = Math.floor((restante / (1000 * 60)) % 60);
    var s = Math.floor((restante / 1000) % 60);
    if (elD) elD.textContent = String(d);
    if (elH) elH.textContent = String(h).padStart(2, '0');
    if (elM) elM.textContent = String(m).padStart(2, '0');
    if (elS) elS.textContent = String(s).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  items.forEach(function (item) {
    var boton = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('is-abierto');
      item.closest('.mt-faq').querySelectorAll('.mt-faq__item').forEach(function (otro) {
        otro.classList.remove('is-abierto');
        otro.querySelector('.mt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('is-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      if (!full || !principal) return;
      principal.src = full;
      miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
      var color = mini.getAttribute('data-color');
      if (color && window.mtSeleccionarColor) window.mtSeleccionarColor(color);
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  initAddToCartAjax(form);
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes = JSON.parse(dataEl.textContent);
  var pillsGrupos = form.querySelectorAll('[data-mt-opcion]');
  var inputId = form.querySelector('[data-mt-variant-id]');
  var precioEl = document.querySelector('[data-mt-precio-actual]');
  var precioTachadoEl = document.querySelector('[data-mt-precio-tachado]');
  var ahorroWrap = document.querySelector('[data-mt-ahorro-wrap]');
  var ahorroEl = document.querySelector('[data-mt-ahorro]');
  var btnAdd = form.querySelector('[data-mt-btn-add]');
  var disponibilidadEl = document.querySelector('[data-mt-disponibilidad]');

  function seleccionActual() {
    var sel = [];
    pillsGrupos.forEach(function (grupo) {
      var activa = grupo.querySelector('.is-selected');
      sel.push(activa ? activa.getAttribute('data-valor') : null);
    });
    return sel;
  }

  function encontrarVariante() {
    var sel = seleccionActual();
    return variantes.find(function (v) {
      return v.opciones.every(function (val, i) { return val === sel[i]; });
    });
  }

  var galeria = document.querySelector('[data-mt-galeria]');
  var imagenPrincipal = galeria ? galeria.querySelector('[data-mt-imagen-principal]') : null;
  var miniaturasGaleria = galeria ? galeria.querySelectorAll('[data-mt-miniatura]') : [];

  function actualizar() {
    var v = encontrarVariante();
    if (!v) return;
    if (inputId) inputId.value = v.id;
    if (precioEl) precioEl.textContent = v.precio;
    if (v.imagen && imagenPrincipal && imagenPrincipal.src !== v.imagen) {
      imagenPrincipal.src = v.imagen;
      miniaturasGaleria.forEach(function (m) {
        m.classList.toggle('is-activa', m.getAttribute('data-full') === v.imagen);
      });
    }
    if (precioTachadoEl) {
      if (v.precioComparado) {
        precioTachadoEl.textContent = v.precioComparado;
        precioTachadoEl.style.display = 'inline';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (ahorroWrap && ahorroEl) {
      if (v.ahorro) {
        ahorroEl.textContent = v.ahorro;
        ahorroWrap.style.display = '';
      } else {
        ahorroWrap.style.display = 'none';
      }
    }
    if (btnAdd) {
      btnAdd.disabled = !v.disponible;
      btnAdd.textContent = v.disponible
        ? btnAdd.getAttribute('data-texto-disponible') + ' - ' + v.precio
        : btnAdd.getAttribute('data-texto-agotado');
    }
    if (disponibilidadEl) {
      disponibilidadEl.textContent = v.disponible ? disponibilidadEl.getAttribute('data-texto-stock') : disponibilidadEl.getAttribute('data-texto-agotado');
    }
  }

  pillsGrupos.forEach(function (grupo) {
    grupo.querySelectorAll('[data-mt-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        grupo.querySelectorAll('[data-mt-pill]').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        actualizar();
      });
    });
  });

  window.mtSeleccionarColor = function (color) {
    if (!color) return;
    var grupoColor = pillsGrupos[0];
    if (!grupoColor) return;
    var pill = Array.prototype.filter.call(grupoColor.querySelectorAll('[data-mt-pill]'), function (p) {
      return p.getAttribute('data-valor') === color;
    })[0];
    if (!pill || pill.classList.contains('is-selected')) return;
    grupoColor.querySelectorAll('[data-mt-pill]').forEach(function (p) { p.classList.remove('is-selected'); });
    pill.classList.add('is-selected');
    actualizar();
  };

  actualizar();
}

function initAddToCartAjax(form) {
  var btn = form.querySelector('[data-mt-btn-add]');
  var errorEl = document.querySelector('[data-mt-error-add]');

  form.addEventListener('submit', function (evt) {
    evt.preventDefault();
    if (btn.disabled) return;

    var textoOriginal = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-texto-cargando') || '...';
    if (errorEl) errorEl.style.display = 'none';

    var formData = new FormData(form);
    formData.append(
      'sections',
      'cart-notification-product,cart-notification-button,cart-icon-bubble'
    );
    formData.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          if (errorEl) {
            errorEl.textContent = data.description || data.message || 'No se pudo añadir al carrito.';
            errorEl.style.display = 'block';
          }
          return;
        }
        var notification = document.querySelector('cart-notification');
        if (notification && typeof notification.renderContents === 'function') {
          notification.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (errorEl) {
          errorEl.textContent = 'No se pudo añadir al carrito. Inténtalo de nuevo.';
          errorEl.style.display = 'block';
        }
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = textoOriginal;
      });
  });
}
